import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;
import axios from "axios";
import VueAxios from "vue-axios";
import SubMenu from "@/components/SubMenu";
import SubMenu2 from "@/components/SubMenu2";
// import vueHeadful from 'vue-headful';

import AsyncComputed from "vue-async-computed";

Vue.use(AsyncComputed);
Vue.use(VueAxios, axios);

import Typo from "@/components/Typo.vue";
import Bubble from "@/components/Bubble.vue";
import Message from "@/components/Message.vue";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

Vue.component("Typo", Typo);
Vue.component("Bubble", Bubble);
Vue.component("Message", Message);
Vue.component("SubMenu", SubMenu);
Vue.component("SubMenu2", SubMenu2);
// Vue.component('vue-headful', vueHeadful);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
